import {
  type ErrorType,
  useApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate,
  useApiLogisticsV1ShipmentsDocumentsUploadCreate,
} from 'api';

import { useUploadAndCreateDocument } from '../../document';

export const useUploadAndCreateShipmentDocument = () => {
  const { mutateAsync: createDocument } = useApiLogisticsV1ShipmentsDocumentsUploadCreate<ErrorType<Error>>();
  const { mutateAsync: generatePreSignedURL } =
    useApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate<ErrorType<Error>>();

  return useUploadAndCreateDocument<{ name: string }>(generatePreSignedURL, createDocument);
};
